import styled from 'styled-components';

export const ChangePasswordNotAvailableContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;
